var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "btn-group mb-2" },
        [
          _c(
            "TabButton",
            {
              attrs: { tab: "general" },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [_vm._v(_vm._s(_vm.$t("map.gps.tracker.modal.edit.tab.general")))]
          ),
          _vm._v(" "),
          _c(
            "TabButton",
            {
              attrs: { tab: "trigger" },
              model: {
                value: _vm.selectedTab,
                callback: function($$v) {
                  _vm.selectedTab = $$v
                },
                expression: "selectedTab"
              }
            },
            [_vm._v(_vm._s(_vm.$t("map.gps.tracker.modal.edit.tab.trigger")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("TabGeneral", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selectedTab === "general",
            expression: "selectedTab === 'general'"
          }
        ],
        attrs: { tracker: _vm.tracker, disabled: _vm.disabled }
      }),
      _vm._v(" "),
      _c("TabTrigger", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selectedTab === "trigger",
            expression: "selectedTab === 'trigger'"
          }
        ],
        attrs: { tracker: _vm.tracker, disabled: _vm.disabled }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }